'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NewSavedSearch = require('./components/NewSavedSearch.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NewSavedSearch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/saved-search/lib/components/new-saved-search/index.js
// module id = 543
// module chunks = 1